import React from "react";

class GridExpandComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { GridValue: "" };
    }
    componentDidMount(){
        this.reportWindowSize();
    }
    reportWindowSize = () => {
        if(window.innerWidth > 768){
          this.setState({GridValue:"k-grid-content-sticky k-hierarchy-cell"})
        }
        else{
          this.setState({GridValue:""})
        }
    }
    render() {
        window.addEventListener('resize', this.reportWindowSize);
        window.addEventListener('load', this.reportWindowSize);

        let dataItem = this.props.dataItem
        return (
            <td className={this.state.GridValue}>
                {dataItem.expanded ?
                    <a
                        onClick={ () => this.props.expandChange(dataItem) }
                        className="k-icon k-minus"
                        
                        tabIndex="-1"
                    ></a>
                    :
                    <a
                        onClick={ () => this.props.expandChange(dataItem) }
                        className="k-icon k-plus"
                        tabIndex="-1"
                    ></a>
                }
            </td>
        )
    }
}
export default GridExpandComponent
